//Node Modules
import { useRecoilValueLoadable } from "recoil";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

//Pages

//BinaryForge Components
import { Loading, Note } from "../helpers";
import { DoughnutChart } from "../report";

//3rd Party Components

//Atoms
import { deviceSummarySelector } from "../../atoms/dashboard";

//Helpers
import { useSensorActuatorLabels } from "../../config/device";

//Other
import { nav } from "../../config/navigation";

//Ring/segment order must match inputData/outputData below
const SEGMENT_TYPES = ["FLOWSTOP", "FLEXIPAD", "RANGER"];

const DeviceSummaryLoader = () => {
	//Recoil
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { state, contents } = useRecoilValueLoadable(deviceSummarySelector);

	//Outer ring (dataset 0) = sensor types, inner ring (dataset 1) = actuator types
	const handleSegmentClick = (datasetIndex, index) => {
		const side = datasetIndex === 0 ? "sensor" : "actuator";
		navigate(`${nav.device.base}/${nav.device.management}?health=${side}-${SEGMENT_TYPES[index].toLowerCase()}`);
	};

	switch (state) {
		case "hasError":
			return (
				<Note
					messageKey={`Error: ${contents.message ? contents.message : contents}`}
					icon="pi-exclamation-circle fontColour-error"
				/>
			);
		case "loading":
			return <Loading />;
		case "hasValue":
			const inputData = {
				FLOWSTOP: contents.inputDevices.FLOWSTOP,
				FLEXIPAD: contents.inputDevices.FLEXIPAD,
				RANGER: contents.inputDevices.RANGER,
			};
			const outputData = {
				FLOWSTOP: contents.outputDevices.FLOWSTOP,
			};
			const labels = Object.keys(inputData).map((label) => t(`device.feature.${label.toLowerCase()}`));
			const sensorLabel = t(useSensorActuatorLabels ? "devices.table.sensorType" : "devices.table.input");
			const actuatorLabel = t(useSensorActuatorLabels ? "devices.table.actuatorType" : "devices.table.output");
			return (
				<>
					<div className="summaryChart-wrapper">
						<div className="summaryChart-center">{contents.total}</div>
						<DoughnutChart
							labels={labels}
							chartData={[inputData, outputData]}
							measureName={[sensorLabel, actuatorLabel]}
							legendId="deviceSummaryLegend"
							onSegmentClick={handleSegmentClick}
						/>
					</div>
					<div className="flexVert text-center fontSize-small fontColour-light marginTop-small">
						<span>{t("dashboard.device.outerRing", { label: sensorLabel })}</span>
						<span>{t("dashboard.device.innerRing", { label: actuatorLabel })}</span>
					</div>
				</>
			);
		default:
			return null;
	}
};

export default DeviceSummaryLoader;
